module.exports = __webpack_public_path__ + "img/programme3.a9ff8577.png";